// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url;
  if (url.search(pattern) >= 0) {
    newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  } else {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}
//  Callback for image loading based on Paul Irish method
$.fn.imagesLoaded = function(callback, fireOne) {
var
  args = arguments,
  elems = this.filter('img'),
  elemsLen = elems.length - 1;
elems
  .bind('load', function(e) {
      if (fireOne) {
          !elemsLen-- && callback.call(elems, e);
      } else {
          callback.call(this, e);
      }
  }).each(function() {
    // cached images don't fire load sometimes, so we reset src.
    if (this.complete || this.complete === undefined){
        this.src = this.src;
    }
  });
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('.accessibleNav'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  }
};

timber.init = function () {
  if(typeof(FastClick) !== 'undefined'){
    FastClick.attach(document.body);
  }
  timber.cacheSelectors();
  timber.accessibleNav();
  // timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};


timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.getHash = function () {
  return window.location.hash;
};

timber.updateHash = function (hash) {
  window.location.hash = '#' + hash;
  $('#' + hash).attr('tabindex', -1).focus();
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      addToCartText = options.addToCartText || "Agregar al carrito",
      membershipProduct = options.membershipProduct || false;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $buttonPrice = $('#ButtonPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
      $quantityInput = $quantityElements.find('input');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = $('.productImg[data-image-id="'+ variant.featured_image.id +'"]');
      var newPosition = newImg.parent().attr('index');

      // Slider not loaded
      if (newPosition === undefined) {
        return;
      }else {
         $('#ProductPhoto').slickGoTo(newPosition);
      }
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(addToCartText);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Agotado");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    if(membershipProduct) {
      $productPrice.html("<span class='money'>" + Shopify.formatMoney(chargeRabbitFields(variant).amount, moneyFormat) + "</span>" + chargeRabbitFields(variant).interval );
      $buttonPrice.html("<span class='money'>" + Shopify.formatMoney(chargeRabbitFields(variant).amount, moneyFormat) + "</span>" + chargeRabbitFields(variant).interval );
    }
    else {
      $productPrice.html("<span class='money'>" + Shopify.formatMoney(variant.price, moneyFormat) + "</span>");

      var quantity,
      quantityLabel = "";
      if($quantityInput.length)
        quantity = $quantityInput.val();
      else
        quantity = 1;

      if(quantity > 1)
        quantityLabel = "(" + quantity + ")";

      $buttonPrice.attr('data-item-price', variant.price);
      $buttonPrice.attr('data-item-quantity', quantity);
      $buttonPrice.html("<span class='money'>" + Shopify.formatMoney(variant.price * quantity, moneyFormat) + "</span>&nbsp;" + quantityLabel);
    }

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("No disponible");
    $quantityElements.hide();
  }
};

timber.switchZoom = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('data-zoom-image', src);
};

// timber.responsiveVideos = function () {
//   $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
//   $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
// };

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

// Initialize Timber's JS on docready
$(timber.init);



/*============================================================================
    Pipeline Functions  )`-....._,.-'``'-.,_,.='``'-.,
==============================================================================*/

window.pipeline = window.pipeline || {};

pipeline.init = function () {
  pipeline.equalHeight();
  pipeline.navClick();
  pipeline.delayNav();
  pipeline.smoothScroll();
  pipeline.detectNav();
  pipeline.tabletMenu();
  pipeline.fullHeight();
  pipeline.contentOverflow();
};

pipeline.equalHeight = function() {
  var $columns = $('.equalHeightColumn');
  $columns.height('initial');
  var height = 0;
  $columns.each(function () {
    if ($(this).height() > height) {
      height = $(this).height();
    }
  });
  $columns.height(height);
};

pipeline.navClick = function() {
  var selector = '.accessibleNav.mobile-only .grandparent > a.nav-carat, .accessibleNav.mobile-only .grandparent > a.nav-link, .accessibleNav.mobile-only .parent > a.nav-carat, .accessibleNav.mobile-only .parent > a.nav-link';
  $(selector).on('click', function(event){
    event.preventDefault();
    $(this).closest('li').toggleClass('main-menu--expanded');
  });
};

pipeline.delayNav = function() {
  var hoverTimeout;
  var linkRemove;
  $('.grandparent').hover(function() {
    if(typeof linkRemove != "undefined") {
      linkRemove.removeClass('hover');
    }
    window.clearTimeout(hoverTimeout);
    var linkAdd = $(this);
    $( linkAdd ).addClass('hover');
  },function() {
    linkRemove = $(this);
    hoverTimeout = window.setTimeout(function() {
      linkRemove.removeClass('hover');
    },250);
  });
};

pipeline.tabletMenu = function() {

    $('.nav--desktop .grandparent > a.nav-link, .nav--desktop main-menu > .parent > a.nav-link').on( 'click', function(event){
      if ( $(this).parent().hasClass('hover') ){
        $(this).parent().removeClass('hover');
      } else{
        event.preventDefault();
        $('.grandparent, .parent').removeClass('hover');
        $(this).parent().addClass('hover');
      }
    });

};

pipeline.smoothScroll = function() {
  $('a[href*=#]:not([href=#]):not([data-toggle])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        if (location.pathname.includes("formula-pro-advanced")) {
          $('html,body').animate({
            scrollTop: target.offset().top - 100
          }, 1000);
          return false;
        } else {
          $('html,body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    }
  });
};

pipeline.detectNav = function(){
  var navWidth = $('.nav--desktop .main-menu').outerWidth();
  var logoWidth = $('.logo-wrapper').outerWidth();
  var widthLimit = $('.site-header .wrapper').width();
  var totalWidth = navWidth + logoWidth;
  $('.site-header, .info-bar').addClass('showDesktop');
  // if ( totalWidth < widthLimit){
  //   $('.site-header, .info-bar').addClass('showDesktop');
  //   $('.site-header, .info-bar').removeClass('showMobile');
  // }
  // else {
  //   $('.site-header, .info-bar').addClass('showMobile');
  //   $('.site-header, .info-bar').removeClass('showDesktop');
  // }
};

pipeline.fullHeight = function(){
  var windowHeight = $(window).height();
  var navHeight = ($('.header__wrapper').height());
  var heroHeight = windowHeight - navHeight;
  $('.main-content > .use_screen_full:first-child').height(heroHeight);
  $('.main-content > .use_screen_full:not(:first-child)').height(windowHeight);
};

pipeline.contentOverflow = function(){
  $('.preventOverflow').css('min-height', function() {
    var contentHeight = $(this).find('.preventOverflowContent').height();
    return (contentHeight + 30);
  });
};

pipeline.positionFooterImage = function() {
  var logoHeight = $('#footerLogoImg').height();
  var logoOffset = ( logoHeight/-2 );
  var logoWidth = $('#footerLogoImg').width();
  var logoHorizontalOffset = ( logoWidth/-2 );
  $('#footerLogo').css('top', logoOffset);
  $('#footerLogo').css('margin-left', logoHorizontalOffset);
  $('#footerLogo').css('opacity', '1');
};
$('#footerLogoImg').imagesLoaded(function() {
  pipeline.positionFooterImage();
});

$(window).resize(function() {
  pipeline.detectNav();
  pipeline.equalHeight();
  pipeline.fullHeight();
  pipeline.contentOverflow();
}).resize();

$('.logo-image').imagesLoaded(function() {
  $(window).resize();
});
$(window).load(function(){
  $(window).resize();
});

$(document).ready(function () {
    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: $(".site-footer-wrapper #sign_up").offset().top
        }, 600);
    });



function proAdvanced() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 6977210581026
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

function instantWarmer() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 28912612212770
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

function sterilizeDryer() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 42855728206
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

function babyBottles() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 27801905731
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}


function makeFood() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 42855718478
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

//time savings calculator 3/19/2020 A2 Creative

    //minute savings per bottle
    var time_multiplier = '';
    var data_id = '';

    $( ".goToStep2" ).on( "click", function(e) {
      //$("body").delegate(".goToStep2", "click", function(){
   		e.preventDefault();
       var data_step = $(this).attr('data-step');
       var data_id = $('.step').attr('data-id', '2');

      //add different savings for different products
      if (data_step == 'make-a-bottle'){
        time_multiplier = 4;
        $('.box2 .inner h2').html('STEP 2: TELL US HOW MANY BOTTLES YOU MAKE A DAY');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/M-BW-IMAGE-4.png?v=1585246603");
        $('.result .content p').html('<strong>SAVE 4 MINUTES per bottle and <span id="minute-savings">30</span> MINUTES a day</strong> using the Baby Brezza Formula Pro Advanced!');
        $('.inline-reviews').attr("data-bv-product-id", "553111519266");
        $('.result .content ul li:first-child').html('Automatically makes a warm formula bottle instantly versus 5+ minutes by hand');
        $('.result .content ul li:nth-child(2)').html('Customizes your bottle by temperature and ounce. Even make a water only bottle');
        $('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> Life Changer!” Baileylynn, Manning, Iowa ');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=KVCJ-If5XSg");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/formula-pro-advanced");
        $('.inline-reviews').attr("data-bv-redirect-url", "/products/formula-pro-advanced#reviews");
        //$('.result .content .btn-grid .btn-3').attr("href", proAdvanced );
        $( ".result .content .btn-grid .btn-3" ).click(function() {
          proAdvanced();
        });
        $('.last-item').css('display', 'none');
      }
      if (data_step == 'warm-a-bottle'){
        time_multiplier = 3;
        $('.box2 .inner h2').html('STEP 2: TELL US HOW MANY BOTTLES YOU MAKE A DAY');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.last-item').css('display', 'none');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/instant-warmer-calc.png?v=1586445605");
        $('.result .content p').html('<strong>SAVE 3 MINUTES per bottle and <span id="minute-savings">30</span> MINUTES a day</strong> using the Baby Brezza Instant Warmer!');
        $('.inline-reviews').attr("data-bv-product-id", "3774180425762");
        $('.result .content ul li:first-child').html('Instantly make a warm formula bottle by dispensing warm water 24/7');
        $('.result .content ul li:nth-child(2)').html('No more waiting 4+ minutes for a traditional bottle warmer to warm up a bottle');
        $('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> “Simple, Best Bottle Warmer!”, CLKobernick, Flushing, NY');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=5ze5iMM2w8Q");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/instant-warmer");
        $( ".result .content .btn-grid .btn-3" ).click(function() {
          instantWarmer();
        });
        $('.inline-reviews').attr("data-bv-redirect-url", "/products/instant-warmer#reviews");
      }
      if (data_step == 'sterilize-bottle'){
        time_multiplier = 5;
        $('.box2 .inner h2').html('Step 2: How many times do you sterilize bottles or pump parts a week?');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.last-item').css('display', 'block');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/STERIDRY.png?v=1585246606");
        $('.result .content p').html('<strong>SAVE 5 MINUTES per bottle and <span id="minute-savings">30</span> MINUTES a week</strong> using the Baby Brezza One Step Sterilizer Dryer!');
        //$('.inline-reviews').attr("data-bv-product-id", "9109738254");
        $('.result .content ul li:first-child').html('Automatically sterilizes & dries bottles, pump parts and other accessories. ');
        $('.result .content ul li:nth-child(2)').html('No more boiling and then air drying on a non-sterilize drying rack which is time consuming and undermines sterilization');
        $('.result .content ul li:nth-child(3)').html('Natural steam kills 99.9% of germs');
        if ($('.result .content ul li.last-child').length){

        }else {
        	$('.result .content ul').append('<li class="last-child">Moms love it! <span>★★★★★</span> “My Best Baby Item”, Wigginc, Greenville, TN</li>');
        }
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=D7TIqW7-od8");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/one-step-sterilizer-dryer");
		$( ".result .content .btn-grid .btn-3" ).click(function() {
          sterilizeDryer();
        });
		//$('.inline-reviews').attr("data-bv-redirect-url", "/products/one-step-sterilizer-dryer#reviews");
      }
      if (data_step == 'handwash-bottle'){
        time_multiplier = 1;
        $('.box2 .inner h2').html('STEP 2: TELL US HOW MANY BOTTLES YOU MAKE A DAY');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.last-item').css('display', 'none');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/baby-single.png?v=1586445426");
        $('.result .content p').html('<strong>SAVE 1 MINUTE per bottle and <span id="minute-savings">30</span> MINUTES a day</strong> using Baby Brezza Natural Bottles!');
        $('.result .content ul li:first-child').html('Automatically sterilizes & dries bottles, pump parts and other accessories. ');
        $('.inline-reviews').attr("data-bv-product-id", "9160493518");
        $('.result .content ul li:first-child').html('Easiest to clean with only 2 parts and ultra-wide – less to clean and less time to assemble');
        $('.result .content ul li:nth-child(2)').html('Breast-like nipples for easy transition between breast & bottle plus anti-colic TruFLo™ vent');
        $('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> “Favorite Bottle!”, Geori08');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=D2lxC30wxIM");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/baby-brezza-bottle-9oz");
		$( ".result .content .btn-grid .btn-3" ).click(function() {
          babyBottles();
        });
        //$('.inline-reviews').attr("data-bv-redirect-url", "/products/5-oz-natural-baby-bottle-3-pack#reviews");
      }
      if (data_step == 'make-food'){
        time_multiplier = 2;
        $('.box2 .inner h2').html('STEP 2: HOW MANY TIMES PER WEEK DO YOU MAKE HOMEMADE BABY FOOD?');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/baby-food_65566375-8de1-48c6-8a51-4da98256967c.png?v=1586445084');
        });
        $('.last-item').css('display', 'none');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/FOOD_MAKER_DELUXE.png?v=1585246607");
        $('.result .content p').html('<strong>SAVE 2 MINUTES per batch and <span id="minute-savings">30</span> MINUTES a week</strong> using the Baby Brezza One Step Food Maker Deluxe!');
        $('.inline-reviews').attr("data-bv-product-id", "9160898254");
        $('.result .content ul li:first-child').html('Automatically steams & blends baby food in 1 easy step! Just press 1 button to make a puree! ');
        $('.result .content ul li:nth-child(2)').html('Make homemade baby food in as little as 10 minutes');
		$('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> “Easy, Fast, Simple!”, Sam2140, Sugar Land, TX ');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=BVaQjnQRjis");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/one-step-baby-food-maker-deluxe");
		$( ".result .content .btn-grid .btn-3" ).click(function() {
          makeFood();
        });
        //$('.inline-reviews').attr("data-bv-redirect-url", "/products/one-step-baby-food-maker-deluxe#reviews");
      }

      step2();
    });
    $( ".goToStep3" ).click(function(e) {
      var bottle_amount = $(this).attr('data-id');
      console.log('minute savings', time_multiplier);
      console.log('bottle amount', bottle_amount);
      var total_savings = bottle_amount * time_multiplier
      var data_id = $('.step').attr('data-id', '3');
      $('#minute-savings').html(total_savings);

        step3();
    });
    $( ".backToStep2" ).click(function(e) {
        backstep2();
        var data_id = $('.step').attr('data-id', '2');
    });
    $( ".backToStep1" ).click(function(e) {
        backstep1();
        var data_id = $('.step').attr('data-id', '1');
    });
    $( ".backToStart" ).click(function(e) {
        backToStart();
        var data_id = $('.step').attr('data-id', '1');
    });




    function step2(){ // inner stuff slides left
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin - container_width); // extra 2 for border
        var newWidth = Math.abs(newLeftMargin);
        //var step_width = $('.step').css('max-width', newLeftMargin);
        //$( ".step" ).animate({maxWidth: newLeftMargin}, 500);
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-2').outerHeight(true );
  		$('.innerLiner').css('height', step_height)
    }
    function step3(){ // inner stuff slides left
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin - container_width); // extra 2 for border
        //var step_width = $('.step').css('max-width', newLeftMargin);
        //$( ".step" ).animate({maxWidth: newLeftMargin}, 500);
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $('html, body').animate({
        	scrollTop: $('.innerLiner').offset().top - 100 //#DIV_ID is an example. Use the id of your destination on the page
        }, 'slow');
        $(".step").css("max-width", container_width);
        $(".step .inner").css("max-width", container_width);
        var step_height = $('.step-3').outerHeight(true );
  		$('.innerLiner').css('height', step_height)
    }
    function backstep2(){ // inner stuff slides right
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin + container_width); // extra 2 for border
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-2').outerHeight(true);
  		$('.innerLiner').css('height', step_height)
        console.log(step_height);
    }
    function backstep1(){ // inner stuff slides right
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin + container_width); // extra 2 for border
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-1').outerHeight(true );
  		$('.innerLiner').css('height', step_height)
    }
    function backToStart(){ // inner stuff slides right
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*2;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin + container_width); // extra 2 for border
        $( ".innerLiner" ).animate({marginLeft: '0px'}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-1').outerHeight(true);
  		$('.innerLiner').css('height', step_height)
    }

    //video popup on savings caluclator final step
  	$('.popup-youtube, .popup-vimeo').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
  setTimeout(function(){

    var step_height = $('.step-1').outerHeight();
    $('.innerLiner').css('height', step_height);
    console.log('outer height', step_height);

  }, 3000);


});


$(window).on('load', function () {
    $( window ).resize(function() {
      var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
      var container_width = $( ".savings-calc-container" ).outerWidth();
      var newLeftMargin = (initalLeftMargin - container_width); // extra 2 for border
      var innerLiner_margin = $( ".innerLiner" ).css('margin-left');
      var data_id = $( ".step" ).attr('data-id');
      var step_height = $('.step').outerHeight(true);
      $('.innerLiner').css('height', step_height);
      //add a data-id number to each "step", and then do an if/else on those numbers. for 2, multiply the width by 2, and then 3.
      if (data_id == '1'){
        console.log('first_section');
      }else if (data_id == '2') {
      	console.log('second_section');
        $( ".innerLiner" ).css('margin-left', -container_width);
      }else if (data_id == '3') {
        console.log('third_section');
        var current_width= $( ".innerLiner" ).css('margin-left');
		console.log('current', current_width);
        console.log('container', container_width);
         $( ".innerLiner" ).css('margin-left', -container_width * 2);
        /*if (container_width < 1500){
          console.log('less than ')
          $( ".innerLiner" ).css('margin-left', -container_width * 2);
        }*/
      }
      $(".step").css("max-width", container_width);
      $(".step .inner").css("max-width", container_width);
    });
  });



// we'll make sure quantity is no more than inventory

window.addEventListener('input', function(e) {
  var theTarget = e.target;
  // console.log({theTarget})
  //check for [max], or get out
  if (theTarget.closest('[max]') === null) return;
  var max = parseInt(theTarget.getAttribute('max'), 10);
  var value = parseInt(theTarget.value, 10) || 0;
  //console.log({max}, {value})
  if (value > max) {
    //alert('We only have ' + max + ' of this item in stock');
    theTarget.value = max;
  }
});



$(pipeline.init);
